










import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import { ModelSync } from 'vue-property-decorator'

@Component({
  components: {
    AdminUserSearch
  }
})
export default class AdminWriterSearch extends Vue {
  @ModelSync('writerId', 'change') writerIdModel: number | string
}
